module.exports = new __parcel__URL__("up.a89c722f.jpg").toString();